export default "__VITE_ASSET__DSwyM8zb__"